const Header =() => {
    return(
<h1 >My Counter using React useState Hook</h1>
    )
}

export default Header;